export const generateUniqueFilename = (filename) => {
    const lastDotIndex = filename.lastIndexOf('.');

    let file_name = '';
    let file_extension = '';

    if (lastDotIndex === -1 || lastDotIndex === 0) {
        file_name = filename;
        file_extension = '';
    } else {
        file_name = filename.substring(0, lastDotIndex);
        file_extension = filename.substring(lastDotIndex + 1);
    }

    const timestamp = new Date().getTime();
    return file_extension
        ? `${file_name}_${timestamp}.${file_extension}`
        : `${file_name}_${timestamp}`;
}